let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bg0Y0")).then(() => parcelRequire('cK9UE'));